import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { site } from '@panel/commons/helpers';
import { getColor } from '@panel/commons/core/themev3';

const siteId = site.id;

const Container = styled.div`
  width: 100%;
  height: ${({ device }) => (device === 'desktop' ? '528px' : 'fit-content')};
  display: flex;
  flex-direction: ${({ device }) => (device === 'desktop' ? 'row' : 'column')};
  align-items: center;
  position: relative;
  .ref-scroll {
    position: absolute;
    top: -70px;
  }
  @media (min-width: 1024px) {
    flex-direction: column;
  }
  @media (min-width: 1366px) {
    flex-direction: row;
  }
  @media (max-width: 820px) {
    height: fit-content;
  }
`;

const ZoneDemandListContainer = styled.div`
  width: ${({ device }) => (device === 'desktop' ? '35%' : '100%')};
  height: ${({ device }) => (device === 'desktop' ? '528px' : 'auto')};
  background-color: ${({ device }) => {
    if (device === 'desktop') {
      if (siteId === 'UBPE') {
        return getColor('tertiary');
      }
      return select('creamDarkOrange');
    }
    return select('white');
  }};
  @media (min-width: 768px) {
    width: 68%;
    background-color: ${select('white')};
  }
  @media (min-width: 1024px) {
    width: 52%;
    background-color: ${select('white')};
  }

  @media (min-width: 1366px) {
    background-color: ${siteId === 'UBPE' ? getColor('tertiary') : select('creamDarkOrange')};
  }
`;

const MapContainer = styled.div`
  width: ${({ device }) => (device === 'desktop' ? '65%' : '100%')};
  // Estilos a modal texto del map:
  .gm-style-mot {
    padding: 0 40px;
    width: 100%;
    white-space: break-spaces;
    text-align: center;
    font-family: 'Hind';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 130%;
  }
  .loading {
    width: 100%;
    text-align: center;
  }
  @media (min-width: 1024px) {
    width: 100%;
  }
`;

const Title = styled.div`
  width: ${({ device }) => (device === 'mobile' ? '360px' : '100%')};
  font-family: 'Hind';
  font-style: normal;
  font-weight: 700;
  font-size: ${({ device }) => (device === 'mobile' ? '24px' : '28px')};
  line-height: 130%;
  text-align: center;
  white-space: break-spaces;
  padding: 0 32px;
  margin-bottom: ${({ device }) => (device === 'mobile' ? '21px' : '16px')};
  margin-top: ${({ device }) => {
    if (device === 'mobile') return '0px';
    if (device === 'tablet') return '10px';
    return '75px';
  }};
  @media (min-width: 1366px) {
    display: none;
  }
`;

export { Container, ZoneDemandListContainer, MapContainer, Title };
